import { Tile, TileProps, useTheme } from "@carrotfertility/carotene-core"
import React from "react"

interface BaseTileProps extends Omit<TileProps, "color"> {
  color?: TileProps["color"]
  children: React.ReactNode
}

export function BaseTile({ color, sx, children, ...props }: BaseTileProps): JSX.Element {
  const theme = useTheme()

  const defaultSx = {
    ...(!color && { backgroundColor: theme.palette.background.paper }),
    border: !color && `${theme.tokens.borderWidth.sm} solid ${theme.palette.divider}`,
    overflow: "hidden",
    padding: theme.spacing(theme.tokens.spacing.md),
    minBlockSize: { xs: "300px", lg: "580px" }
  }

  return (
    <Tile color={color} sx={{ ...defaultSx, ...sx }} {...props}>
      {children}
    </Tile>
  )
}
